import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.css']
})
export class BlogDetailComponent implements OnInit {
blogData:any={}
imageUrlArray:any=[]
include:any= ['facebook', 'twitter','whatsapp','pinterest','linkedin']
comments:any=[
  { text:'Nice blog!!' ,likes:2 }, 
  { text:'Very well exaplained!!' ,likes:0 } 
]
comment:any=''
errorComment:boolean=false
blogId:any=''
review:any={}
  constructor(private auth:AuthService,
    private activatedRoute:ActivatedRoute,
    ) { }

  ngOnInit() {
    if(this.activatedRoute.snapshot.params.id){
     // this.blogId = this.activatedRoute.snapshot.params.id
      console.log('yes')
      this.getSingleBlog()
    }
  }
  loginFirst(){
    let islogin = localStorage.getItem('token')
    //console.log(islogin)
    if(islogin){
      document.getElementById('add_comment_trigger').click()
    }
    else{
      document.getElementById('logintoggle_user').click()
    }
  }
  increaseLike(index){
    this.comments[index].likes = this.comments[index].likes + 1
  }
  addComment(){
    if(this.comment==''){
      this.errorComment=true
    }
    else{
      this.auth.addBlogReview({blogId:this.blogId,comment:this.comment}).subscribe(res=>{
        this.getSingleBlog()
        this.errorComment = false
        document.getElementById('add_comment_trigger').click()
      })
    }
    this.comments.push({text:this.comment,likes:0})
    this.comment=''
  }
  showImagePopup(image){
    this.imageUrlArray=[]
    this.imageUrlArray.push(image)
    document.getElementById('orderImagesCLick').click()
  }
  getSingleBlog(){
    this.auth.getSingleBlog(this.activatedRoute.snapshot.params.id).subscribe(res=>{
     console.log(res)
      this.blogData = res["data"][0]
      if(localStorage.getItem('token')){
      let index = this.blogData.reviews.findIndex(review=>review.userId._id==JSON.parse(localStorage.getItem('logindata'))['_id'])
    if(index>-1){
      this.review.isLiked  = this.blogData.reviews[index].isLiked ? this.blogData.reviews[index].isLiked  : false
    }
    else{
      this.review.isLiked=false
    }  
    }
      this.blogId = this.blogData._id
    
    },error=>{

    })


  }
  loginFirstLike(data){
    if(localStorage.getItem('usertype')=='User' && localStorage.getItem('token')){
      this.like(data)
    }
    else if(!localStorage.getItem('token')){
      document.getElementById('logintoggle_user').click()
    }
    
  }
  like(article){
    let obj={
      isLiked:article.isLiked ? false : true,
      blogId:this.blogId
    }
    this.auth.addBlogReview(obj).subscribe(res=>{
      this.getSingleBlog()
    })
  }
  parseInt(number){
    return parseInt(number)
  }
  getDays(time){
    let diff = new Date().getTime()-time
    //console.log(diff)
    let days = diff/(1000*60*60*24)
   
    return days
  }

}
